import React from 'react';
import { string, func } from 'prop-types';
import { Link } from 'react-router-dom';

// Import components
import {
	Description,
	ButtonsWrapper,
	ButtonStyled,
	ButtonText
} from './styles';

// Import translation
import { useTranslation } from 'react-i18next';

// Import variables
import { ROUTES_CORE_PATHS, LOGIN_SYSTEM_TYPES } from 'helpers/variables';

const { pureott } = LOGIN_SYSTEM_TYPES;
const { REGISTER } = ROUTES_CORE_PATHS;

const LoginModal = ({ toggle, providerType, sourceName }) => {
	const { t } = useTranslation();
	const isOperator = sourceName !== pureott;

	const modalDescriptionTranslation = isOperator
		? t('common_login_form_provider_modal_description_operator')
		: t('common_login_form_provider_modal_description');

	const modalDescription = modalDescriptionTranslation.replace(
		':providerType',
		providerType
	);

	return (
		<>
			<Description description>
				{modalDescription}{' '}
				{!isOperator && (
					<span>{t('common_login_form_provider_modal_description_span')}</span>
				)}
			</Description>
			<ButtonsWrapper isOperator={isOperator}>
				<ButtonStyled onClick={toggle}>
					<ButtonText>
						{t('common_login_form_provider_modal_login_button')}
					</ButtonText>
				</ButtonStyled>
				{!isOperator && (
					<ButtonStyled as={Link} to={`/${REGISTER}`} remove>
						<ButtonText>
							{t('common_login_form_provider_modal_register_button')}
						</ButtonText>
					</ButtonStyled>
				)}
			</ButtonsWrapper>
		</>
	);
};

LoginModal.propTypes = {
	toggle: func.isRequired,
	providerType: string.isRequired,
	sourceName: string
};

export default LoginModal;
